@if (userForm) {
  <div class="input-field-size-max">
    <form [formGroup]="userForm" novalidate class="needs-validation">
      <ix-typography
        format="h4"
        id="{{ userFormType }}_userFormUserProfileCategoryHeader"
        >
        {{ 'um.category_user_profile' | translate }}
      </ix-typography>
      <ix-input formControlName="firstName"
        type="text"
        [id]="userFormType + '_firstName'"
        [label]="'um.first_name' | translate"
        class="col-md-12 mt-2 input-field-size-max"
        [class.ix-invalid]="!userForm.controls['firstName'].untouched && userForm.controls['firstName'].errors"
        [invalidText]="getFormFieldError('firstName') | translate"
        />
        <ix-input formControlName="lastName"
          type="text"
          [id]="userFormType + '_lastName'"
          [label]="'um.last_name' | translate"
          class="col-md-12 mt-2 input-field-size-max"
          [class.ix-invalid]="!userForm.controls['lastName'].untouched && userForm.controls['lastName'].errors"
          [invalidText]="getFormFieldError('lastName') | translate" />
          <ix-input formControlName="email"
            type="email"
            [id]="userFormType + '_email'"
            [label]="'um.email' | translate"
            class="col-md-12 mt-2 input-field-size-max"
            [class.ix-invalid]="!userForm.controls['email'].untouched && userForm.controls['email'].errors"
            [invalidText]="getFormFieldError('email') | translate" />
            @if (availableOrganizations && availableOrganizations.length > 0) {
              <ix-input formControlName="organization"
                type="text"
                [id]="userFormType + '_organization'"
                [label]="'organizations.header' | translate"
                class="col-md-12 mt-2 input-field-size-max"
                [class.ix-invalid]="!userForm.controls['organization'].untouched && userForm.controls['organization'].errors"
                [invalidText]="getFormFieldError('organization') | translate" />
              }
              @let rolesSource = (userFormType === 'admin-save' || userFormType === 'invite') ? manageableRoles
              : (userFormType === 'save' ? availableRoles : null) ;
              @if (rolesSource && rolesSource.length > 0) {
                <ix-select formControlName="roles"
                  [i18nPlaceholder]="userFormType === 'save' ? '' : ('um.select_role' | translate)"
                  i18nSelectListHeader="{{ 'general.select_list_header' | translate }}"
                  [id]="userFormType + '_roles'"
                  [label]="'um.roles_title' | translate"
                  mode="multiple"
                  class="col-md-12 mt-2 input-field-size-max"
                  [class.ix-invalid]="!userForm.controls['roles'].untouched && userForm.controls['roles'].errors"
                  [invalidText]="getFormFieldError('roles') | translate">
                  @for (role of rolesSource; track role) {
                    <ix-select-item [label]="'um.roles.' + role.label | translate"
                      [value]="role.id" />
                    }
                  </ix-select>
                }
                <ix-typography
                  class="mt-4"
                  format="h4"
                  id="{{ userFormType }}_userFormUserRegionLanguageHeader"
                  >
                  {{ 'um.category_r_l' | translate }}
                </ix-typography>
                <ix-select formControlName="region"
                  i18nSelectListHeader="{{ 'general.select_list_header' | translate }}"
                  [id]="userFormType + '_region'"
                  [label]="'um.region' | translate"
                  class="col-md-12 input-field-size-max"
                  [class.ix-invalid]="!userForm.controls['region'].untouched && userForm.controls['region'].errors"
                  [invalidText]="getFormFieldError('region') | translate">
                  <ix-select-item label="{{ 'um.region_eu' | translate }}"
                    selected="selected"
                    value="EU" />
                  </ix-select>
                  <ix-select formControlName="language"
                    i18nSelectListHeader="{{ 'general.select_list_header' | translate }}"
                    [id]="userFormType + '_language'"
                    [label]="'um.language' | translate"
                    class="col-md-12 mt-2 input-field-size-max"
                    [class.ix-invalid]="!userForm.controls['language'].untouched && userForm.controls['language'].errors"
                    [invalidText]="getFormFieldError('language') | translate">
                    @for (lang of availableLanguages; track lang.code) {
                      <ix-select-item [label]="lang.nativeName" [value]="lang.code" />
                    }
                  </ix-select>
                </form>
                <div class="col-md-12 input-field-size-max mt-4">
                  <ix-modal-footer>
                    <ix-button
                      (click)="onCancel()"
                      [disabled]="loading"
                      class="dismiss-modal"
                      id="{{ userFormType }}_userFormCancelButton"
                      variant="secondary"
                      onKeyUp=""
                      >
                      {{ 'general.cancel' | translate }}
                    </ix-button>
                    <ix-button
                      (click)="onSubmit()"
                      [loading]="loading"
                      class="close-modal"
                      id="{{ userFormType }}_userFormSubmitButton"
                      variant="primary"
                      onKeyUp=""
                      >
                      {{ 'um.' + userFormType.toLowerCase() | translate }}
                    </ix-button>
                  </ix-modal-footer>
                </div>
              </div>
            }

            <div class="d-flex justify-content-center">
              @if (!userForm) {
                <ix-spinner size="large" class="mt-5"></ix-spinner>
              }
            </div>

            <ng-template #cancelModal let-modal>
              <div>
                @if (userFormType !== 'invite') {
                  <ix-modal-header id="{{ userFormType }}_userFormCancelModalHeader"
                    >{{
                    'um.cancel.headline'
                    | translate
                    : {
                    firstName: modal.data.firstName,
                    lastName: modal.data.lastName,
                  }
                  }}
                </ix-modal-header>
                <ix-modal-content id="{{ userFormType }}_userFormCancelModalContent"
                  >{{
                  'um.cancel.text'
                  | translate
                  : {
                  firstName: modal.data.firstName,
                  lastName: modal.data.lastName,
                }
                }}
              </ix-modal-content>
            }
            @if (userFormType === 'invite') {
              <ix-modal-header id="{{ userFormType }}_userFormCancelModalInviteHeader"
                >{{
                'um.cancel.invite.headline'
                | translate
                : {
                firstName: modal.data.firstName,
                lastName: modal.data.lastName,
              }
              }}
            </ix-modal-header>
            <ix-modal-content id="{{ userFormType }}_userFormCancelModalInviteContent"
              >{{
              'um.cancel.invite.text'
              | translate
              : {
              firstName: modal.data.firstName,
              lastName: modal.data.lastName,
            }
            }}
          </ix-modal-content>
        }

        <ix-modal-footer>
          <ix-button
            (click)="modal.close(true)"
            class="dismiss-modal"
            id="{{ userFormType }}_userFormCancelModalYesButton"
            variant="secondary"
            onKeyUp=""
            >
            {{ 'general.yes' | translate }}
          </ix-button>
          <ix-button
            (click)="modal.dismiss()"
            class="close-modal"
            id="{{ userFormType }}_userFormCancelModalNoButton"
            variant="primary"
            onKeyUp=""
            >
            {{ 'general.no' | translate }}
          </ix-button>
        </ix-modal-footer>
      </div>
    </ng-template>
